/**
 * PocketFiler - Spanish (es) Translation File
 * Complete translation - all keys from en.js
 */

const es = {
  "nav.login": "Iniciar sesión",
  "nav.signup": "Comenzar",
  "nav.logout": "Cerrar sesión",
  "nav.dashboard": "Panel",
  "nav.virtualOffices": "Oficinas Virtuales",
  "nav.clients": "Clientes",
  "nav.deals": "Negocios",
  "nav.documents": "Documentos",
  "nav.messages": "Mensajes",
  "nav.settings": "Configuración",
  "nav.invoices": "Facturas",
  "nav.templates": "Plantillas",
  "nav.tasks": "Tareas",
  "nav.meetings": "Reuniones",
  "nav.analytics": "Análisis",
  "landing.badge": "Plataforma de Negocios con IA",
  "landing.hero.title": "Cierra Negocios Importantes en Cualquier Idioma",
  "landing.hero.titleHighlight": "con IA",
  "landing.hero.subtitle": "PocketFiler ayuda a empresas e individuos a realizar transacciones complejas y de alta confianza – desde comercio global hasta ventas de autos locales y pólizas de seguros – con traducción de IA, flujos de documentos y Salas de Negocios para cada transacción.",
  "landing.hero.cta.start": "Comenzar Gratis",
  "landing.hero.cta.demo": "Ver cómo funciona",
  "landing.useCases.title": "Diseñado para Comercio Global, Servicios Locales y Grandes Transacciones Personales",
  "landing.useCases.subtitle": "Ya sea que importes productos del extranjero o vendas tu auto en tu ciudad, PocketFiler te da las herramientas para cerrar con confianza.",
  "landing.useCases.globalTrade.title": "Comercio Global y Manufactura",
  "landing.useCases.globalTrade.desc": "Encuentra y trabaja con proveedores extranjeros, recopila documentos de cumplimiento y negocia en Salas de Negocios con traducción en tiempo real.",
  "landing.useCases.insurance.title": "Seguros, Préstamos y Servicios Profesionales",
  "landing.useCases.insurance.desc": "Invita a clientes a subir identificaciones, estados de cuenta y formularios en su idioma, luego rastrea cada documento y mensaje en Oficinas Virtuales.",
  "landing.useCases.realEstate.title": "Bienes Raíces y Transacciones de Propiedades",
  "landing.useCases.realEstate.desc": "Guía a compradores e inquilinos a través de solicitudes, divulgaciones y contratos en diferentes idiomas, todo dentro de una sola Sala de Negocios por transacción.",
  "landing.useCases.vehicle.title": "Ventas de Vehículos y Activos Privados",
  "landing.useCases.vehicle.desc": "Usa Salas de Negocios y contratos generados por IA para manejar facturas de venta y documentación de autos, equipos y otros artículos de alto valor.",
  "landing.audience.title": "Diseñado para Individuos y Equipos",
  "landing.audience.individuals.title": "Para Individuos",
  "landing.audience.individuals.bullet1": "Cierra negocios importantes como compras de autos, equipos o artículos de alto valor con registros claros.",
  "landing.audience.individuals.bullet2": "Usa enlaces seguros y simples para subir documentos y revisar contratos desde tu teléfono.",
  "landing.audience.individuals.bullet3": "Mantén todos los mensajes, archivos y borradores de contratos de cada negocio en un solo lugar, incluso después de cerrado.",
  "landing.audience.teams.title": "Para Empresas y Equipos",
  "landing.audience.teams.bullet1": "Configura Oficinas Virtuales para cada línea de servicio (seguros, bienes raíces, préstamos, importaciones) con listas de verificación personalizadas.",
  "landing.audience.teams.bullet2": "Invita a clientes en cualquier idioma a subir documentos, firmar contratos y comunicarse dentro de Salas de Negocios.",
  "landing.audience.teams.bullet3": "Dale a tu equipo un espacio de trabajo compartido con líneas de tiempo, resúmenes de IA e historial completo para cada transacción.",
  "landing.howItWorks.title": "Cómo Funciona PocketFiler para Cualquier Negocio",
  "landing.howItWorks.subtitle": "Cuatro características poderosas que trabajan juntas para ayudarte a cerrar negocios más rápido y con menos fricción.",
  "landing.howItWorks.concierge.title": "Concierge de IA",
  "landing.howItWorks.concierge.desc": "Tu asistente de IA aprende sobre tu negocio, configura las Oficinas Virtuales correctas y crea listas de documentos para cada tipo de transacción.",
  "landing.howItWorks.translation.title": "Traducción Automática",
  "landing.howItWorks.translation.desc": "Los mensajes y contenido clave se traducen instantáneamente entre las partes, para que compradores, vendedores y clientes puedan comunicarse en su propio idioma.",
  "landing.howItWorks.documents.title": "Documentos Inteligentes",
  "landing.howItWorks.documents.desc": "Los clientes suben documentos desde su teléfono; la IA extrae campos clave, verifica calidad y señala problemas antes de que retrasen el negocio.",
  "landing.howItWorks.dealRooms.title": "Salas de Negocios y Contratos",
  "landing.howItWorks.dealRooms.desc": "Cada negocio obtiene una sala dedicada con línea de tiempo, mensajes, documentos y borradores de contratos generados por IA que puedes revisar y finalizar.",
  "landing.cta.title": "¿Listo para cerrar tu próximo negocio?",
  "landing.cta.subtitle": "Únete a empresas e individuos que usan PocketFiler para manejar transacciones importantes con confianza.",
  "landing.cta.button": "Crear Cuenta Gratis",
  "landing.footer.tagline": "Negocios importantes simplificados.",
  "language.picker.title": "Elige tu idioma",
  "language.picker.subtitle": "Te mostraremos todas las instrucciones, mensajes y contratos en este idioma. Otros pueden elegir su propio idioma; la IA se encargará de la traducción.",
  "language.picker.continue": "Continuar",
  "language.picker.playSample": "Reproducir muestra",
  "language.picker.playing": "Reproduciendo...",
  "language.picker.confirmation": "Has seleccionado {language}. Te mostraremos todo en este idioma. Otras partes pueden elegir su propio idioma; PocketFiler traduce mensajes, documentos y contratos para que todos entiendan.",
  "language.toast.saved": "¡Idioma guardado! Para cambiarlo, ve a Configuración en tu perfil.",
  "language.confirm.title": "Confirma tu idioma",
  "language.confirm.subtitle": "Este idioma se usará para toda la interfaz, mensajes y contratos.",
  "language.confirm.change": "Cambiar idioma",
  "language.confirm.continue": "Continuar con",
  "language.confirm.chineseNote": "Nota: Has seleccionado chino simplificado (简体中文). Si prefieres chino tradicional, por favor cambia tu selección.",
  "auth.login.title": "Bienvenido de vuelta",
  "auth.login.subtitle": "Inicia sesión en tu cuenta PocketFiler",
  "auth.login.email": "Correo electrónico",
  "auth.login.password": "Contraseña",
  "auth.login.submit": "Iniciar sesión",
  "auth.login.noAccount": "¿No tienes cuenta?",
  "auth.login.signupLink": "Regístrate",
  "auth.login.error": "Correo o contraseña inválidos",
  "auth.signup.title": "Crea tu cuenta",
  "auth.signup.subtitle": "Comienza a cerrar negocios en cualquier idioma",
  "auth.signup.name": "Nombre completo",
  "auth.signup.email": "Correo electrónico",
  "auth.signup.password": "Contraseña",
  "auth.signup.confirmPassword": "Confirmar contraseña",
  "auth.signup.companyName": "Nombre de la empresa",
  "auth.signup.companyType": "Tipo de industria",
  "auth.signup.submit": "Crear cuenta",
  "auth.signup.hasAccount": "¿Ya tienes cuenta?",
  "auth.signup.loginLink": "Inicia sesión",
  "auth.signup.terms": "Al registrarte, aceptas nuestros Términos de Servicio y Política de Privacidad.",
  "dashboard.title": "Panel",
  "dashboard.welcome": "Bienvenido de vuelta, {name}",
  "dashboard.aiSummary.title": "Resumen de IA",
  "dashboard.aiSummary.generating": "Generando resumen...",
  "dashboard.stats.totalDeals": "Total de Negocios",
  "dashboard.stats.activeDeals": "Negocios Activos",
  "dashboard.stats.totalClients": "Total de Clientes",
  "dashboard.stats.documentsProcessed": "Documentos Procesados",
  "dashboard.recentDeals.title": "Negocios Recientes",
  "dashboard.recentDeals.viewAll": "Ver todos",
  "dashboard.recentDeals.empty": "Aún no hay negocios. Crea tu primer negocio para comenzar.",
  "dashboard.recentClients.title": "Clientes Recientes",
  "dashboard.recentClients.viewAll": "Ver todos",
  "dashboard.recentClients.empty": "Aún no hay clientes. Invita a tu primer cliente para comenzar.",
  "dashboard.quickActions.title": "Acciones Rápidas",
  "dashboard.quickActions.createDeal": "Crear Negocio",
  "dashboard.quickActions.inviteClient": "Invitar Cliente",
  "dashboard.quickActions.createOffice": "Crear Oficina Virtual",
  "offices.title": "Oficinas Virtuales",
  "offices.subtitle": "Organiza tu negocio por tipo de servicio",
  "offices.create": "Crear Oficina Virtual",
  "offices.empty.title": "Aún no hay oficinas virtuales",
  "offices.empty.desc": "Crea tu primera Oficina Virtual para organizar tus negocios y clientes.",
  "offices.card.clients": "{count} clientes",
  "offices.card.deals": "{count} negocios",
  "offices.card.checklist": "Elementos de checklist",
  "offices.checklist": "Lista de Documentos",
  "offices.noChecklist": "Sin documentos requeridos",
  "offices.dialog.title": "Crear Oficina Virtual",
  "offices.dialog.desc": "Configura un nuevo espacio de trabajo para un tipo específico de servicio",
  "offices.dialog.name": "Nombre de la oficina",
  "offices.dialog.namePlaceholder": "ej: Reclamos de Seguros, Ventas Inmobiliarias",
  "offices.dialog.type": "Tipo de oficina",
  "offices.dialog.description": "Descripción",
  "offices.dialog.descriptionPlaceholder": "Describe qué maneja esta oficina...",
  "offices.dialog.checklist": "Lista de Documentos",
  "offices.dialog.checklistHelp": "Lista generada por IA de documentos requeridos",
  "offices.dialog.addItem": "Agregar elemento",
  "offices.dialog.generateChecklist": "Generar con IA",
  "offices.dialog.creating": "Creando...",
  "offices.dialog.create": "Crear Oficina",
  "offices.form.name": "Nombre de la oficina",
  "offices.form.namePlaceholder": "ej: Servicios de Seguros, Bienes Raíces, etc.",
  "offices.form.description": "Descripción",
  "offices.form.descPlaceholder": "¿Qué tipo de negocios manejará esta oficina?",
  "offices.form.checklistPlaceholder": "Agregar documento requerido...",
  "offices.ai.title": "Configuración Asistida por IA",
  "offices.ai.desc": "Deja que nuestro Concierge de IA te ayude a configurar la oficina virtual perfecta preguntándote sobre las necesidades de tu negocio.",
  "offices.ai.manual": "Configurar Manualmente",
  "offices.ai.start": "Iniciar Configuración con IA",
  "offices.ai.startOnboarding": "Ayúdame a configurar mi oficina virtual",
  "offices.ai.suggestion": "Sugerencia de IA",
  "offices.ai.acceptSuggestion": "Aceptar y Crear Oficina",
  "offices.ai.inputPlaceholder": "Escribe tu respuesta...",
  "clients.title": "Clientes",
  "clients.subtitle": "Gestiona tus clientes e invitaciones",
  "clients.invite": "Invitar Cliente",
  "clients.empty.title": "Aún no hay clientes",
  "clients.empty.desc": "Invita a tu primer cliente para comenzar.",
  "clients.table.name": "Nombre",
  "clients.table.client": "Cliente",
  "clients.table.contact": "Contacto",
  "clients.table.office": "Oficina",
  "clients.table.language": "Idioma",
  "clients.table.status": "Estado",
  "clients.table.actions": "Acciones",
  "clients.status.invited": "Invitado",
  "clients.status.active": "Activo",
  "clients.status.completed": "Completado",
  "clients.dialog.title": "Invitar Nuevo Cliente",
  "clients.dialog.name": "Nombre del cliente",
  "clients.dialog.email": "Correo electrónico",
  "clients.dialog.phone": "Número de teléfono",
  "clients.dialog.office": "Oficina Virtual",
  "clients.dialog.language": "Idioma preferido",
  "clients.dialog.sending": "Enviando invitación...",
  "clients.dialog.send": "Enviar Invitación",
  "clients.toast.invited": "Invitación enviada a {name}",
  "clients.toast.deleted": "Cliente eliminado",
  "clients.toast.linkCopied": "Enlace de invitación copiado al portapapeles",
  "clients.invite.step1Title": "Invitar Nuevo Cliente",
  "clients.invite.step2Title": "Vista previa del mensaje",
  "clients.invite.step3Title": "¡Invitación Enviada!",
  "clients.invite.step1Desc": "Ingresa la información de contacto del cliente",
  "clients.invite.step2Desc": "Revisa y personaliza el mensaje de invitación",
  "clients.invite.step3Desc": "Comparte el enlace de invitación con tu cliente",
  "clients.invite.nameLabel": "Nombre del cliente",
  "clients.invite.namePlaceholder": "ej: Juan Pérez",
  "clients.invite.contactMethod": "Método de contacto",
  "clients.invite.phone": "Número de teléfono",
  "clients.invite.customNote": "Nota personalizada",
  "clients.invite.customNotePlaceholder": "Instrucciones especiales para este cliente...",
  "clients.invite.previewMessage": "Vista previa del mensaje",
  "clients.invite.aiGenerated": "Mensaje de invitación generado por IA",
  "clients.invite.messagePreview": "Vista previa del mensaje",
  "clients.invite.messageEditHint": "Puedes editar este mensaje antes de enviar",
  "clients.invite.documentsRequested": "Documentos solicitados",
  "clients.invite.regenerate": "Regenerar mensaje",
  "clients.invite.sendInvite": "Enviar Invitación",
  "clients.invite.linkCreated": "¡Enlace de Invitación Creado!",
  "clients.invite.linkCopiedToClipboard": "El enlace ha sido copiado a tu portapapeles",
  "clients.invite.shareLink": "Comparte este enlace con tu cliente por correo, SMS o en persona",
  "clients.invite.inviteAnother": "Invitar Otro",
  "clients.invite.success": "¡Cliente invitado!",
  "clients.invite.linkCopied": "¡Enlace copiado!",
  "clients.invite.yourAgent": "Tu agente",
  "clients.invite.defaultOffice": "Nuestra Oficina",
  "deals.title": "Negocios",
  "deals.subtitle": "Rastrea y gestiona tus transacciones",
  "deals.create": "Crear Negocio",
  "deals.empty.title": "Aún no hay negocios",
  "deals.empty.desc": "Crea tu primer negocio para comenzar.",
  "deals.search": "Buscar negocios...",
  "deals.filter.all": "Todos los Negocios",
  "deals.filter.active": "Activos",
  "deals.filter.pending": "Pendientes",
  "deals.filter.closed": "Cerrados",
  "deals.column.draft": "Borrador",
  "deals.column.active": "Activos",
  "deals.column.pending": "Pendientes",
  "deals.column.pending_documents": "Documentos Pendientes",
  "deals.column.pending_signature": "Firma Pendiente",
  "deals.column.pending_payment": "Pago Pendiente",
  "deals.column.escrow_funded": "Fondos en Custodia",
  "deals.column.release_requested": "Liberación Solicitada",
  "deals.column.disputed": "En Disputa",
  "deals.column.on_hold": "En Espera",
  "deals.column.completed": "Completados",
  "deals.column.cancelled": "Cancelados",
  "deals.column.closed": "Cerrados",
  "deals.card.documents": "{count} documentos",
  "deals.card.messages": "{count} mensajes",
  "deals.dialog.title": "Crear Nuevo Negocio",
  "deals.dialog.dealTitle": "Título del negocio",
  "deals.dialog.dealTitlePlaceholder": "ej: Compra de Vehículo - Honda Civic 2023",
  "deals.dialog.client": "Cliente",
  "deals.dialog.office": "Oficina Virtual",
  "deals.dialog.type": "Tipo de negocio",
  "deals.dialog.notes": "Notas",
  "deals.dialog.notesPlaceholder": "Agrega notas sobre este negocio...",
  "deals.dialog.creating": "Creando...",
  "deals.dialog.create": "Crear Negocio",
  "dealRoom.back": "Volver a Negocios",
  "dealRoom.readOnly.title": "Solo Lectura",
  "dealRoom.readOnly.closedMessage": "Este negocio ha sido cerrado. La Sala de Negocios es ahora de solo lectura para referencia y auditoría.",
  "dealRoom.readOnly.cancelledMessage": "Este negocio ha sido cancelado. La Sala de Negocios es ahora de solo lectura para referencia y auditoría.",
  "dealRoom.tabs.messages": "Mensajes",
  "dealRoom.tabs.documents": "Documentos",
  "dealRoom.tabs.contract": "Contrato",
  "dealRoom.timeline.title": "Línea de Tiempo",
  "dealRoom.timeline.empty": "Aún no hay actividad",
  "dealRoom.details.title": "Detalles del Negocio",
  "dealRoom.details.notes": "Notas",
  "dealRoom.details.type": "Tipo",
  "dealRoom.details.documents": "Documentos",
  "dealRoom.details.messages": "Mensajes",
  "dealRoom.aiSummary.title": "Resumen de IA",
  "dealRoom.aiSummary.generating": "Generando resumen...",
  "dealRoom.messages.empty": "Aún no hay mensajes. Inicia la conversación.",
  "dealRoom.messages.placeholder": "Escribe un mensaje...",
  "dealRoom.messages.send": "Enviar",
  "dealRoom.messages.sending": "Enviando...",
  "dealRoom.messages.showOriginal": "Mostrar original",
  "dealRoom.messages.showTranslation": "Mostrar traducción",
  "dealRoom.messages.translatedFrom": "Traducido de {language}",
  "dealRoom.messages.suggestReply": "Sugerir Respuesta",
  "dealRoom.documents.empty": "Aún no se han subido documentos.",
  "dealRoom.documents.upload": "Subir Documento",
  "dealRoom.documents.uploading": "Subiendo...",
  "dealRoom.documents.analyze": "Analizar",
  "dealRoom.documents.analyzing": "Analizando...",
  "dealRoom.documents.download": "Descargar",
  "dealRoom.documents.delete": "Eliminar",
  "dealRoom.documents.pending": "Análisis Pendiente",
  "dealRoom.documents.analyzed": "Analizado",
  "dealRoom.documents.aiAnalysis": "Análisis de Documento con IA",
  "dealRoom.documents.type": "Tipo de Documento",
  "dealRoom.documents.confidence": "Confianza",
  "dealRoom.documents.summary": "Resumen",
  "dealRoom.documents.issues": "Problemas",
  "dealRoom.contract.empty.title": "Aún no se ha generado contrato",
  "dealRoom.contract.empty.desc": "Genera un borrador de contrato con IA para este negocio.",
  "dealRoom.contract.generate": "Generar Borrador de Contrato",
  "dealRoom.contract.regenerate": "Regenerar Contrato",
  "dealRoom.contract.generating": "Generando...",
  "dealRoom.contract.aiLabel": "Borrador de contrato generado por IA",
  "dealRoom.contract.language": "Idioma",
  "dealRoom.contract.copy": "Copiar",
  "dealRoom.contract.copied": "Copiado al portapapeles",
  "dealRoom.contract.type": "Tipo de Contrato",
  "dealRoom.contract.generated": "Generado",
  "dealRoom.contract.languages": "Idiomas",
  "dealRoom.contract.status": "Estado",
  "dealRoom.contract.notice": "Análisis de documento con IA: Una o más cláusulas no tienen equivalente directo entre los idiomas seleccionados. Hemos usado lenguaje descriptivo. Por favor revisa estas secciones cuidadosamente y confirma con la otra parte si es necesario.",
  "dealRoom.contract.dialog.title": "Generar Borrador de Contrato",
  "dealRoom.contract.dialog.desc": "La IA generará un contrato bilingüe basado en los detalles del negocio.",
  "dealRoom.contract.dialog.disclaimer": "Este es un borrador generado por IA para revisión. Consulta con un profesional legal antes de firmar.",
  "dealRoom.contract.dialog.type": "Tipo de Contrato",
  "dealRoom.contract.dialog.languages": "Idiomas",
  "dealRoom.contract.dialog.languagesHelp": "Selecciona dos idiomas para tu contrato bilingüe. Todos los idiomas Tier 1 son completamente soportados.",
  "dealRoom.contract.dialog.primary": "Primario",
  "dealRoom.contract.dialog.secondary": "Secundario",
  "dealRoom.contract.dialog.terms": "Términos Especiales",
  "dealRoom.contract.dialog.termsPlaceholder": "Agrega términos o condiciones especiales...",
  "dealRoom.contract.dialog.generate": "Generar Contrato",
  "dealRoom.contract.dialog.generating": "Generando...",
  "dealRoom.status.change": "Cambiar Estado",
  "dealRoom.status.dialog.title": "Cambiar Estado del Negocio",
  "dealRoom.status.dialog.from": "De",
  "dealRoom.status.dialog.to": "A",
  "dealRoom.status.dialog.reason": "Razón (opcional)",
  "dealRoom.status.dialog.reasonPlaceholder": "¿Por qué cambias el estado?",
  "dealRoom.status.dialog.confirm": "Confirmar Cambio",
  "dealRoom.status.dialog.changing": "Cambiando...",
  "dealRoom.status.toast.changed": "Estado cambiado a {status}",
  "dealRoom.upgrade.title": "Actualizar a Business",
  "dealRoom.upgrade.desc": "La generación de contratos requiere un plan Business.",
  "dealRoom.upgrade.features": "Con Business, obtienes:",
  "dealRoom.upgrade.feature1": "Borradores de contratos generados por IA",
  "dealRoom.upgrade.feature2": "Análisis avanzado de documentos",
  "dealRoom.upgrade.feature3": "Soporte prioritario",
  "dealRoom.upgrade.button": "Actualizar Ahora",
  "settings.title": "Configuración",
  "settings.subtitle": "Gestiona tu cuenta y organización",
  "settings.tabs.profile": "Perfil",
  "settings.tabs.organization": "Organización",
  "settings.profile.title": "Configuración del Perfil",
  "settings.profile.subtitle": "Gestiona tu información personal",
  "settings.profile.name": "Nombre completo",
  "settings.profile.email": "Correo electrónico",
  "settings.profile.emailNote": "El correo no se puede cambiar",
  "settings.profile.language": "Idioma preferido",
  "settings.profile.languageHelp": "Toda la interfaz, mensajes y contratos se mostrarán en este idioma.",
  "settings.profile.save": "Guardar Cambios",
  "settings.profile.saving": "Guardando...",
  "settings.profile.saved": "Perfil actualizado",
  "settings.org.title": "Configuración de Organización",
  "settings.org.subtitle": "Gestiona la información de tu negocio",
  "settings.org.name": "Nombre de organización",
  "settings.org.type": "Tipo de industria",
  "settings.org.billingEmail": "Correo de facturación",
  "settings.org.plan": "Plan",
  "settings.org.verification": "Estado de verificación",
  "settings.org.save": "Guardar Cambios",
  "settings.org.saving": "Guardando...",
  "settings.org.saved": "Organización actualizada",
  "settings.org.noOrg": "Organización no encontrada",
  "invite.language.title": "Elige tu idioma",
  "invite.language.subtitle": "Te mostraremos todas las instrucciones en tu idioma.",
  "invite.welcome.title": "Bienvenido a",
  "invite.welcome.subtitle": "Estamos listos para recibir tus documentos.",
  "invite.welcome.time": "5-10 minutos",
  "invite.welcome.timeLabel": "Tiempo estimado",
  "invite.welcome.secure": "Seguro y Gratuito",
  "invite.welcome.secureDesc": "Tus documentos están encriptados. Este servicio es gratuito para ti.",
  "invite.welcome.start": "Comenzar a Subir",
  "invite.documents.needed": "Documentos necesarios",
  "invite.upload.title": "Subir Documento",
  "invite.upload.dragDrop": "Arrastra y suelta un archivo aquí, o haz clic para seleccionar",
  "invite.upload.or": "o",
  "invite.upload.takePhoto": "Imágenes",
  "invite.upload.browse": "Archivos",
  "invite.upload.uploading": "Subiendo...",
  "invite.upload.analyzing": "Verificando documento...",
  "invite.upload.success": "Subido exitosamente",
  "invite.upload.next": "Siguiente Documento",
  "invite.upload.finish": "Revisar Todos",
  "invite.upload.skip": "Omitir por ahora",
  "invite.upload.progress": "Progreso",
  "invite.complete.title": "¡Listo!",
  "invite.complete.subtitle": "Tus documentos han sido enviados exitosamente.",
  "invite.complete.message": "Hemos recibido todos tus documentos. Te contactaremos pronto.",
  "invite.complete.summary": "Documentos enviados",
  "invite.complete.securityNote": "Tus documentos se almacenan de forma segura y solo serán accedidos por personal autorizado.",
  "invite.chat.title": "Chat con tu agente",
  "invite.chat.placeholder": "Escribe un mensaje...",
  "invite.chat.empty": "Aún no hay mensajes. Inicia una conversación.",
  "invite.chat.sent": "Tu mensaje ha sido enviado.",
  "invite.chat.willRespond": "Te responderemos lo antes posible.",
  "invite.chat.sending": "Enviando...",
  "invite.error.title": "Enlace Inválido o Expirado",
  "invite.error.message": "Este enlace de invitación ya no es válido. Por favor contacta al remitente para un nuevo enlace.",
  "common.loading": "Cargando...",
  "common.save": "Guardar",
  "common.cancel": "Cancelar",
  "common.delete": "Eliminar",
  "common.edit": "Editar",
  "common.create": "Crear",
  "common.close": "Cerrar",
  "common.dismiss": "Descartar",
  "common.confirm": "Confirmar",
  "common.back": "Atrás",
  "common.next": "Siguiente",
  "common.previous": "Anterior",
  "common.of": "de",
  "common.search": "Buscar",
  "common.filter": "Filtrar",
  "common.sort": "Ordenar",
  "common.viewAll": "Ver todos",
  "common.refresh": "Actualizar",
  "common.retry": "Reintentar",
  "common.yes": "Sí",
  "common.no": "No",
  "common.or": "o",
  "common.and": "y",
  "common.optional": "opcional",
  "common.required": "requerido",
  "status.draft": "Borrador",
  "status.active": "Activo",
  "status.pending": "Pendiente",
  "status.pending_documents": "Documentos Pendientes",
  "status.pending_signature": "Firma Pendiente",
  "status.on_hold": "En Espera",
  "status.closed": "Cerrado",
  "status.cancelled": "Cancelado",
  "error.generic": "Algo salió mal. Por favor intenta de nuevo.",
  "error.network": "Error de red. Por favor verifica tu conexión.",
  "error.unauthorized": "No estás autorizado para realizar esta acción.",
  "error.notFound": "El recurso solicitado no fue encontrado.",
  "error.validation": "Por favor verifica tu entrada e intenta de nuevo.",
  "error.serverError": "Error del servidor. Por favor intenta más tarde.",
  "success.saved": "Cambios guardados exitosamente.",
  "success.created": "Creado exitosamente.",
  "success.deleted": "Eliminado exitosamente.",
  "success.sent": "Enviado exitosamente.",
  "success.uploaded": "Subido exitosamente.",
  "time.justNow": "Ahora mismo",
  "time.minutesAgo": "hace {count} minutos",
  "time.hoursAgo": "hace {count} horas",
  "time.daysAgo": "hace {count} días",
  "time.today": "Hoy",
  "time.yesterday": "Ayer",
  "dealRoom.notFound": "Negocio no encontrado",
  "dealRoom.loading": "Cargando negocio...",
  "dealRoom.conversation.title": "Conversación del Negocio",
  "dealRoom.conversation.you": "Tú",
  "dealRoom.conversation.client": "Cliente",
  "dealRoom.messages.hideOriginal": "Ocultar original",
  "dealRoom.messages.original": "Original ({language})",
  "dealRoom.messages.disabled": "Mensajes deshabilitados para este estado",
  "dealRoom.messages.aiSuggest": "Respuesta sugerida por IA",
  "dealRoom.documents.title": "Documentos",
  "dealRoom.documents.uploadDisabled": "Subida Deshabilitada",
  "dealRoom.documents.pendingAnalysis": "Análisis Pendiente",
  "dealRoom.documents.uploadFirst": "Subir Primer Documento",
  "dealRoom.documents.uploadHelp": "Sube documentos para análisis de IA",
  "dealRoom.documents.uploadDisabledHelp": "La subida de documentos está deshabilitada para este estado",
  "dealRoom.documents.analyzeWithAI": "Analizar con IA",
  "dealRoom.documents.notAnalyzed": "Aún no analizado",
  "dealRoom.documents.notAnalyzedHelp": "Ejecuta análisis de IA para extraer tipo de documento, campos y obtener información",
  "dealRoom.documents.analyzeDocument": "Analizar Documento",
  "dealRoom.documents.extractedFields": "Campos Extraídos",
  "dealRoom.documents.issuesDetected": "Problemas Detectados",
  "dealRoom.documents.preview": "Vista Previa",
  "dealRoom.documents.uploaded": "Subido",
  "dealRoom.documents.deleteConfirm": "¿Estás seguro de que quieres eliminar este documento?",
  "dealRoom.onHold.message": "Este negocio está en espera. La subida de documentos está deshabilitada. Aún puedes enviar mensajes para coordinación.",
  "dealRoom.pendingSignature.message": "El contrato está listo para firmar. La subida de documentos está deshabilitada hasta que se firme o revierta el contrato.",
  "dealRoom.status.current": "actual",
  "dealRoom.status.finalWarning": "Este es un estado final. El negocio no se puede reabrir después de esta acción.",
  "dealRoom.contract.purchaseAgreement": "Contrato de Compraventa",
  "dealRoom.contract.purchaseAgreementDesc": "Contrato estándar de compraventa",
  "dealRoom.contract.noContract": "Aún Sin Contrato",
  "dealRoom.contract.noContractDesc": "Genera un borrador de contrato con IA basado en los detalles y documentos del negocio.",
  "dealRoom.contract.notAvailable": "La generación de contratos no está disponible para negocios {status}.",
  "dealRoom.contract.locked": "La generación de contratos está bloqueada mientras espera firma.",
  "dealRoom.contract.requiresPlan": "Requiere plan Business Starter",
  "dealRoom.toast.dealUpdated": "Negocio actualizado",
  "dealRoom.toast.statusChanged": "Estado del negocio cambiado a {status}",
  "dealRoom.toast.statusFailed": "Error al cambiar estado",
  "dealRoom.toast.contractGenerated": "Borrador de contrato generado exitosamente",
  "dealRoom.toast.contractCopied": "Contrato en {language} copiado al portapapeles",
  "dealRoom.toast.messageFailed": "Error al enviar mensaje",
  "dealRoom.toast.suggestionFailed": "Error al generar sugerencia",
  "dealRoom.toast.documentUploaded": "Documento subido",
  "dealRoom.toast.uploadFailed": "Error al subir",
  "dealRoom.toast.analysisComplete": "Análisis de documento con IA completado",
  "dealRoom.toast.analysisFailed": "Error en análisis de IA",
  "dealRoom.toast.documentDeleted": "Documento eliminado",
  "dealRoom.toast.deleteFailed": "Error al eliminar",
  "dealRoom.details.created": "Creado",
  "dealRoom.details.addNotes": "Agregar notas del negocio...",
  "onboarding.brand": "PocketFiler",
  "onboarding.skip": "Omitir por ahora",
  "onboarding.badge": "Configuración con IA",
  "onboarding.welcome": "¡Bienvenido, {name}!",
  "onboarding.welcomeGeneric": "¡Bienvenido!",
  "onboarding.subtitle": "Configuremos tu espacio de trabajo PocketFiler. Cuéntale a nuestro Concierge de IA sobre tu negocio, y configuraremos todo por ti.",
  "onboarding.step1": "Describe tu negocio y necesidades",
  "onboarding.step2": "La IA sugiere tu configuración",
  "onboarding.step3": "Comienza a gestionar negocios",
  "onboarding.concierge.title": "Concierge de IA",
  "onboarding.toast.officeCreated": "¡Oficina virtual creada!",
  "auth.signup.accountType": "Tipo de Cuenta",
  "auth.signup.passwordTooShort": "La contraseña debe tener al menos 8 caracteres",
  "auth.signup.passwordsDoNotMatch": "Las contraseñas no coinciden",
  "auth.signup.success": "¡Cuenta creada exitosamente!",
  "captions.connecting": "Conectando...",
  "captions.disable": "Desactivar Subtítulos",
  "captions.enable": "Activar Subtítulos",
  "captions.error.connect": "Error al conectarse al servicio de subtítulos",
  "captions.error.toggle": "Error al alternar subtítulos",
  "captions.language": "Idioma de Subtítulos",
  "captions.live": "En Vivo",
  "captions.off": "Subtítulos Desactivados",
  "captions.on": "Subtítulos Activados",
  "captions.original": "Original",
  "captions.translated": "Traducido",
  "captions.translating": "Traduciendo...",
  "clients.joined.empty.desc": "Aún no se ha unido a ninguna organización. Pídales que lo inviten a su espacio de trabajo de PocketFiler.",
  "clients.joined.empty.title": "No se Ha Unido a Organizaciones",
  "clients.nav.joinedOrgs": "Organizaciones Unidas",
  "clients.nav.myClients": "Mis Clientes",
  "clients.table.joinedDate": "Fecha de Unión",
  "clients.table.organization": "Organización",
  "common.backToHome": "Volver al Inicio",
  "common.deleteConfirmDesc": "Esta acción no se puede deshacer. Esto eliminará permanentemente el elemento y removerá los datos de nuestros servidores.",
  "common.deleteConfirmTitle": "¿Está absolutamente seguro?",
  "common.noResults": "No se encontraron resultados",
  "connect.createAccount": "Crear Cuenta Gratuita",
  "connect.dealCreated": "Negocio creado exitosamente",
  "connect.error.invalid": "Enlace de Conexión Inválido",
  "connect.error.invalidDesc": "Este enlace de conexión es inválido o ha expirado.",
  "connect.error.server": "Algo salió mal",
  "connect.error.serverDesc": "Por favor intente de nuevo más tarde.",
  "connect.infoUnauth": "Esta persona usa PocketFiler para gestionar negocios y documentos multiidioma de forma segura.",
  "connect.joinOffice": "Unirse a Oficina Virtual",
  "connect.loggedInAs": "Conectado como",
  "connect.login": "Iniciar Sesión",
  "connect.startDeal": "Iniciar un Negocio",
  "connect.titleAuth": "Se está conectando con",
  "connect.titleUnauth": "Conectarse con",
  "connect.typeOrg": "Organización",
  "connect.typePerson": "Persona",
  "contacts.actions.call": "Llamar",
  "contacts.actions.email": "Correo Electrónico",
  "contacts.actions.message": "Enviar Mensaje en la App",
  "contacts.actions.noEmail": "Sin dirección de correo",
  "contacts.actions.noPhone": "Sin número de teléfono",
  "contacts.actions.sms": "Mensaje de Texto",
  "contacts.actions.title": "Contacto {name}",
  "contacts.actions.whatsapp": "WhatsApp",
  "contacts.dialog.name": "Nombre del Contacto",
  "contacts.dialog.title": "Agregar Nuevo Contacto",
  "contacts.empty.desc": "Agregue su primer contacto para comenzar.",
  "contacts.empty.title": "Aún no hay contactos",
  "contacts.invite": "Agregar Contacto",
  "contacts.invite.customNotePlaceholder": "Cualquier nota especial sobre este contacto...",
  "contacts.invite.nameLabel": "Nombre del Contacto",
  "contacts.invite.shareLink": "Comparta este enlace con su contacto por email, SMS, o en persona",
  "contacts.invite.step1Desc": "Ingrese información del contacto",
  "contacts.invite.step1Title": "Agregar Nuevo Contacto",
  "contacts.subtitle": "Gestione sus contactos e invitaciones",
  "contacts.table.contact": "Contacto",
  "contacts.title": "Contactos",
  "contacts.toast.deleted": "Contacto eliminado",
  "contacts.toast.invited": "Contacto agregado: {name}",
  "contacts.toast.linkCopied": "Enlace copiado al portapapeles",
  "dashboard.quickActions.inviteContact": "Agregar Contacto",
  "dashboard.recentContacts.empty": "Aún no hay contactos. Invite a su primer contacto para comenzar.",
  "dashboard.recentContacts.title": "Contactos Recientes",
  "dashboard.recentContacts.viewAll": "Ver todos",
  "dashboard.stats.totalContacts": "Contactos Totales",
  "dealRoom.contract.analysisWarning": "Algunos documentos aún no han sido analizados. El análisis de IA mejora la precisión del contrato.",
  "dealRoom.conversation.colleague": "Colega",
  "dealRoom.details.clients": "Clientes",
  "dealRoom.documents.previewNotAvailable": "Vista previa no disponible. Descargando...",
  "dealRoom.incomingCall.accept": "Aceptar",
  "dealRoom.incomingCall.decline": "Rechazar",
  "dealRoom.incomingCall.inProgress": "Llamada en progreso",
  "dealRoom.incomingCall.started": "{name} inició una llamada",
  "dealRoom.messages.connecting": "Conectando al chat...",
  "dealRoom.messages.connectionError": "No se puede conectar a la conversación.",
  "dealRoom.pendingSignature.loading": "Cargando estado de firma...",
  "dealRoom.pendingSignature.signedWaitingOthers": "Firmado exitosamente. Esperando a otros participantes.",
  "dealRoom.readOnly.completedMessage": "Este negocio se ha completado exitosamente. La Sala de Negocios ahora es de solo lectura para propósitos de referencia y auditoría.",
  "dealRoom.signature.signed": "Firmado",
  "dealRoom.signature.signedByYou": "Firmado por usted",
  "dealRoom.signature.success": "¡Contrato firmado exitosamente!",
  "dealRoom.signaturesList.clients": "Clientes",
  "dealRoom.signaturesList.dealOwner": "Propietario del negocio",
  "dealRoom.signaturesList.pending": "Pendiente",
  "dealRoom.signaturesList.signedOn": "Firmado el",
  "dealRoom.signaturesList.title": "Firmas",
  "dealRoom.signaturesList.viewSignatures": "Ver firmas",
  "dealRoom.signedByAll.addPayment": "Agregar Pago",
  "dealRoom.signedByAll.message": "Firmado por todos los participantes. Proceder al Pago.",
  "dealRoom.timeline.createdBy": "por {name}",
  "deals.tabs.all": "Todos los Negocios",
  "deals.tabs.my": "Mis Negocios",
  "deals.validation.clientRequired": "Por favor seleccione al menos un cliente",
  "deals.validation.notesLength": "Las notas deben tener 200 caracteres o menos",
  "deals.validation.titleLength": "El título debe tener 100 caracteres o menos",
  "deals.validation.titleRequired": "El título del negocio es requerido",
  "documents.readAloud.analyzeFirst": "Analice este documento primero para leerlo en voz alta.",
  "documents.readAloud.error": "Error al leer en voz alta",
  "documents.readAloud.title": "Leer en voz alta",
  "landing.cta.secondary": "Ver una Sala de Negocios de Ejemplo",
  "landing.hero.trust": "Plan gratuito. No requiere tarjeta de crédito. Compatible con 11 idiomas.",
  "landing.socialProof": "Confiado por más de 500 empresas en 40 países",
  "landing.useCases.personal.desc": "Cierre acuerdos importantes únicos como vehículos, equipos o propiedades con registros claros, contratos de IA, y enlaces seguros simples para compartir documentos.",
  "landing.useCases.personal.title": "Transacciones Personales de Alto Valor",
  "landing.useCases.professional.desc": "Invite a clientes a subir documentos con asistencia de IA, realice seguimiento de cada interacción en Oficinas Virtuales Seguras, y genere contratos digitales bilingües—todo desde un solo espacio de trabajo.",
  "landing.useCases.professional.subtitle": "Seguros, Bienes Raíces, Préstamos",
  "landing.useCases.professional.title": "Servicios Profesionales",
  "livekit.call": "Llamada",
  "livekit.connecting": "Conectando...",
  "livekit.error.connect": "Error al conectarse a la llamada. Por favor intente de nuevo.",
  "livekit.error.connection": "Error de conexión. Por favor verifique su red e intente de nuevo.",
  "livekit.error.permission": "No tiene permisos para unirse a esta llamada.",
  "livekit.hint": "Hable dentro de este Negocio en lugar de cambiar aplicaciones.",
  "livekit.inCall": "En Llamada",
  "livekit.joinCall": "Unirse a la llamada",
  "livekit.leaveCall": "Salir de la llamada",
  "livekit.participant": "participante",
  "livekit.participants": "participantes",
  "messages.readAloud.error": "Error al leer en voz alta",
  "messages.readAloud.title": "Leer en voz alta",
  "nav.companyProfile": "Perfil de Empresa",
  "nav.contacts": "Contactos",
  "nav.directory": "Directorio",
  "nav.products": "Productos",
  "offices.card.contacts": "{count} contactos",
  "pwa.banner.install": "Instalar",
  "pwa.banner.subtitle": "Acceso más rápido, funciona sin conexión",
  "pwa.banner.title": "Obtenga la App de PocketFiler",
  "pwa.firefox.hint": "En Firefox, busque el ícono de instalación (⊕) en la barra de direcciones para agregar esta app a su escritorio.",
  "pwa.installApp": "Instalar App",
  "pwa.installed": "¡App instalada exitosamente!",
  "pwa.ios.description": "Agregue PocketFiler a su pantalla de inicio para la mejor experiencia:",
  "pwa.ios.gotIt": "Entendido",
  "pwa.ios.inToolbar": "en la barra de herramientas de su navegador",
  "pwa.ios.inTopRight": "en la esquina superior derecha",
  "pwa.ios.shareButton": "botón Compartir",
  "pwa.ios.step1": "Toque el",
  "pwa.ios.step2": "Desplace hacia abajo y toque",
  "pwa.ios.step3": "Toque",
  "pwa.ios.title": "Instalar PocketFiler",
  "pwa.iosHint": "Toque el ícono Compartir y \"Agregar a Pantalla de Inicio\" para instalar PocketFiler.",
  "pwa.opera.chromeHint": "abra esta página, luego haga clic en el ícono de instalación en la barra de direcciones",
  "pwa.opera.desktopNotSupported": "Opera desktop no soporta instalación PWA. Para instalar PocketFiler como aplicación, por favor ábralo en Google Chrome o Microsoft Edge.",
  "pwa.opera.edgeHint": "abra esta página, luego haga clic en el ícono de instalación (⊕) en la barra de direcciones",
  "pwa.opera.mobileAddPage": "Agregar página a",
  "pwa.opera.mobileDescription": "Toque el ícono + en la parte inferior de Opera, o use el menú a continuación:",
  "pwa.opera.mobileHomeScreen": "Pantalla de inicio",
  "pwa.opera.mobileStep1": "Toque el",
  "pwa.opera.mobileStep1b": "ícono más (+) en la barra inferior de Opera",
  "pwa.opera.mobileStep2": "O toque",
  "pwa.opera.mobileTitle": "Instalar PocketFiler en Opera",
  "pwa.opera.recommendedBrowsers": "Use en su lugar:",
  "pwa.opera.title": "No disponible en Opera",
  "qr.clickToExpand": "Haga clic para ver en pantalla completa",
  "qr.copied": "¡Copiado!",
  "qr.copyLink": "Copiar Enlace",
  "qr.description": "Muestre este código a clientes o socios. Cuando lo escaneen, pueden conectarse con usted e iniciar un negocio en segundos.",
  "qr.download": "Descargar",
  "qr.generate": "Generar Código QR",
  "qr.linkCopied": "Enlace copiado al portapapeles",
  "qr.primaryLanguage": "Idioma principal",
  "qr.regenerate": "Restablecer",
  "qr.regenerated": "Código QR regenerado. Los enlaces anteriores ya no son válidos.",
  "qr.scanInstructions": "Escanee este QR con PocketFiler o cualquier escáner QR para conectarse.",
  "qr.scanToConnect": "Escanear para Conectar",
  "qr.share": "Compartir",
  "qr.title": "Comparta su QR de PocketFiler",
  "qr.yourLink": "Su enlace de conexión:",
  "recording.completed": "Grabación completada",
  "recording.confirmDelete": "¿Eliminar esta grabación?",
  "recording.delete": "Eliminar",
  "recording.deleted": "Grabación eliminada",
  "recording.download": "Descargar",
  "recording.error.delete": "Error al eliminar grabación",
  "recording.error.noCall": "No hay llamada activa. Por favor únase a la llamada primero.",
  "recording.error.start": "Error al iniciar grabación",
  "recording.error.stop": "Error al detener grabación",
  "recording.failed": "Grabación falló",
  "recording.noRecordings": "Aún no hay grabaciones",
  "recording.play": "Reproducir",
  "recording.playback": "Reproducción de Grabación",
  "recording.processing": "Procesando...",
  "recording.start": "Grabar",
  "recording.started": "Grabación iniciada",
  "recording.stop": "Detener",
  "recording.stopped": "Grabación detenida. Procesando...",
  "recording.viewRecordings": "Ver Grabaciones",
  "schedule.button": "Programar",
  "schedule.cancel": "Cancelar",
  "schedule.chooseDateTime": "Por favor elija fecha y hora",
  "schedule.create": "Programar",
  "schedule.created": "Programado",
  "schedule.dateTime": "Fecha y hora",
  "schedule.description": "Elija una fecha y hora. Puede unirse a la llamada cuando sea el momento.",
  "schedule.title": "Programar llamada o grabación",
  "schedule.type": "Tipo",
  "schedule.typeCall": "Llamada",
  "schedule.typeRecording": "Grabación",
  "schedule.upcoming": "Próximos programados",
  "settings.profile.accountType": "Tipo de Cuenta",
  "settings.profile.accountTypeHelp": "Elija el tipo que mejor lo describa",
  "settings.tabs.sharing": "Compartir QR",
  "support.askAI": "Preguntar a la IA",
  "support.availableTimes": "Horarios disponibles",
  "support.booked": "¡Llamada programada exitosamente!",
  "support.bookingConfirmed": "Perfecto, he programado su llamada para {time}. Recibirá una confirmación con el enlace de la llamada. ¿Hay algo más en lo que pueda ayudar?",
  "support.bookingError": "Error al reservar horario. Por favor intente de nuevo.",
  "support.clearChat": "Limpiar chat",
  "support.error": "Error al enviar mensaje. Por favor intente de nuevo.",
  "support.inYourTime": "en su hora local",
  "support.inputPlaceholder": "Escriba su pregunta...",
  "support.openChat": "Abrir soporte de IA",
  "support.scheduleCall": "Programar una llamada con soporte",
  "support.scheduleTitle": "Programar una Llamada de Soporte",
  "support.slotsError": "Error al cargar horarios disponibles.",
  "support.subtitle": "Pregunte cualquier cosa sobre PocketFiler",
  "support.title": "Soporte de IA",
  "support.welcome": "¡Hola! Soy el asistente de IA de PocketFiler. Puedo ayudarlo con:\\n\\n- Crear y gestionar negocios\\n- Enviar documentos para firma\\n- Usar la función de conexión QR\\n- Invitar clientes\\n- Cualquier otra pregunta sobre PocketFiler\\n\\n¿Cómo puedo ayudarlo hoy?",
  "support.yourTimezone": "Su zona horaria",
  "validation.emailInvalid": "Formato de correo electrónico inválido",
  "validation.emailRequired": "El correo electrónico es requerido",
  "validation.nameRequired": "El nombre es requerido",
  "validation.nameTooLong": "El nombre debe tener menos de 50 caracteres",
  "validation.noteTooLong": "La nota debe tener menos de 200 caracteres",
  "validation.phoneInvalid": "Número de teléfono inválido (10-15 dígitos)",
  "validation.phoneRequired": "El número de teléfono es requerido",
  "dashboard.actions.addClient": "Agregar Cliente",
  "dashboard.actions.all": "Todo",
  "dashboard.actions.createContract": "Crear Contrato",
  "dashboard.actions.createInvoice": "Crear Factura",
  "dashboard.actions.customize": "Personalizar",
  "dashboard.actions.newDeal": "Nueva Oferta",
  "dashboard.actions.scheduleMeeting": "Programar Reunión",
  "dashboard.actions.uploadDocument": "Subir Documento",
  "dashboard.actions.viewAll": "Ver Todo",
  "dashboard.briefing.default": "Nada urgente por ahora. Tu espacio de trabajo está en buena forma.",
  "dashboard.briefing.title": "Informe Diario",
  "dashboard.empty.activity": "No hay actividad reciente.",
  "dashboard.empty.deals": "Aún no hay ofertas. Crea tu primera oferta para ver el pipeline.",
  "dashboard.empty.documents": "Todos los documentos están actualizados.",
  "dashboard.empty.meetings": "No hay reuniones próximas.",
  "dashboard.empty.tasks": "No hay tareas abiertas.",
  "dashboard.greeting.afternoon": "Buenas tardes",
  "dashboard.greeting.evening": "Buenas noches",
  "dashboard.greeting.morning": "Buenos días",
  "dashboard.greeting.subtitle": "Esto es lo que está sucediendo en tu espacio de trabajo.",
  "dashboard.stats.documents": "Documentos",
  "dashboard.stats.invoicesDue": "Facturas Pendientes",
  "dashboard.stats.meetingsComing": "Reuniones Próximas",
  "dashboard.stats.tasksDue": "Tareas Pendientes",
  "dashboard.stats.unreadMessages": "Mensajes Sin Leer",
  "dashboard.widgets.dealPipeline": "Pipeline de Ofertas",
  "dashboard.widgets.documentsAttention": "Documentos que Requieren Atención",
  "dashboard.widgets.gettingStarted": "Primeros Pasos",
  "dashboard.widgets.quickActions": "Acciones Rápidas",
  "dashboard.widgets.recentActivity": "Actividad Reciente",
  "dashboard.widgets.tasks": "Tareas",
  "dashboard.widgets.upcomingMeetings": "Próximas Reuniones",
  "dashboard.steps.createDeal": "Crea tu primer acuerdo",
  "dashboard.steps.addClient": "Agregar un cliente",
  "dashboard.steps.uploadDocument": "Subir un documento",
  "dashboard.steps.scheduleMeeting": "Programar una reunión",
  "dashboard.steps.createInvoice": "Crear una factura",
  "dashboard.steps.addLogo": "Agregar tu logo",
  "dashboard.steps.complete": "completado",
  "dashboard.time.overdue": "Vencido",
  "dashboard.time.today": "Hoy",
  "dashboard.time.tomorrow": "Mañana",
  "dashboard.time.noDate": "Sin fecha",
  "dashboard.docReason.sent": "Enviado, esperando respuesta",
  "dashboard.docReason.notAnalyzed": "Aún no analizado",
  "dashboard.docReason.draft": "Borrador, no finalizado",
  "dashboard.docReason.needsReview": "Necesita revisión",
  "docViewer.notFound": "Documento no encontrado",
  "docViewer.previewUnavailable": "Vista previa no disponible para este tipo de archivo",
  "docViewer.aiAnalysis": "Análisis AI",
  "docViewer.documentType": "Tipo de Documento",
  "docViewer.summary": "Resumen",
  "docViewer.extractedFields": "Campos Extraídos",
  "docViewer.issues": "Problemas",
  "docViewer.tags": "Etiquetas",
  "docViewer.noPreviousVersions": "Sin versiones anteriores",
  "docViewer.noActivity": "Sin actividad aún",
  "auth.forgotPassword.title": "Restablecer su contraseña",
  "guestSign.loading": "Cargando contrato...",
  "guestSign.unableToLoad": "No se Puede Cargar el Contrato",
  "guestSign.signed": "Contrato Firmado",
  "guestSign.createOwn": "¿Desea crear y administrar sus propios contratos?",
  "guestSign.secureSign": "Firma segura",
  "meeting.ended": "Esta reunión ha finalizado",
  "meeting.cancelled": "Reunión Cancelada",
  "meeting.notFound": "Reunión No Encontrada",
  "meeting.joiningAs": "Uniéndose como",
  "meeting.yourName": "Su Nombre *",
  "meeting.emailOptional": "Correo electrónico (opcional)",
  "notFound.title": "Página no encontrada",
  "notFound.dashboard": "Ir al Panel",
  "notFound.home": "Inicio",
  "auth.resetPassword.invalidLink": "Enlace inválido",
  "auth.resetPassword.title": "Establecer nueva contraseña",
  "templates.category": "Categoría",
  "templates.legal": "Legal",
  "templates.sales": "Ventas",
  "templates.services": "Servicios",
  "templates.finance": "Finanzas",
  "templates.library": "Biblioteca de Plantillas",
  "templates.libraryDesc": "Plantillas de documentos listas para usar para su negocio",
  "templates.noDefault": "Ninguna plantilla predeterminada coincide con su búsqueda.",
  "templates.noCustom": "No se encontraron plantillas personalizadas",
  "templates.delete": "Eliminar Plantilla",
  "templates.cancel": "Cancelar",
  "uploadRequest.notFound": "Solicitud No Encontrada",
  "uploadRequest.error": "Algo salió mal",
  "uploadRequest.errorDesc": "Inténtelo de nuevo más tarde o comuníquese con la persona que envió esta solicitud.",
  "uploadRequest.uploaded": "¡Documentos Subidos!",
  "uploadRequest.title": "Solicitud de Subida de Documento",
  "uploadRequest.fileTypes": "PDF, imágenes, documentos Word - máximo 25MB",
  "verify.verifying": "Verificando su correo electrónico...",
  "verify.success": "¡Correo Electrónico Verificado!",
  "verify.signIn": "Iniciar Sesión",
  "verify.alreadyVerified": "Ya Verificado",
  "verify.invalidLink": "Enlace Inválido",
  "verify.backToLogin": "Volver al Inicio de Sesión",
  "documents.documents": "Documentos",
  "documents.allStatus": "Todos los Estados",
  "documents.newFolder": "Nueva Carpeta",
  "documents.clear": "Limpiar",
  "documents.noDocumentsYet": "Aún no hay documentos",
  "documents.status": "Estado",
  "documents.type": "Tipo",
  "documents.uploadedBy": "Subido por",
  "documents.previewNotAvailable": "Vista previa no disponible",
  "documents.aiAnalysis": "Análisis AI",
  "documents.documentType": "Tipo de Documento",
  "documents.summary": "Resumen",
  "documents.extractedFields": "Campos Extraídos",
  "documents.issues": "Problemas",
  "documents.notYetAnalyzed": "Aún no analizado",
  "documents.details": "Detalles",
  "documents.size": "Tamaño",
  "documents.date": "Fecha",
  "documents.mimeType": "Tipo MIME",
  "documents.noTags": "Sin etiquetas",
  "documents.changeStatus": "Cambiar Estado",
  "documents.versionHistory": "Historial de Versiones",
  "documents.noPreviousVersions": "Sin versiones anteriores",
  "documents.activityLog": "Registro de Actividad",
  "documents.noActivityRecordedYet": "Aún no se ha registrado actividad",
  "documents.uploadDocuments": "Subir Documentos",
  "documents.dragAndDropFiles": "Arrastre y suelte archivos o haga clic para explorar. Se admiten PDF, imágenes y documentos Word.",
  "documents.shareDocument": "Compartir Documento",
  "documents.done": "Hecho",
  "documents.emailOptional": "Correo electrónico (opcional)",
  "documents.leaveEmptyToJust": "Deje vacío para solo generar un enlace",
  "documents.messageOptional": "Mensaje (opcional)",
  "documents.cancel": "Cancelar",
  "documents.requestDocuments": "Solicitar Documentos",
  "documents.sendASecureUpload": "Enviar un enlace de carga seguro a un cliente por correo electrónico.",
  "documents.clientEmail": "Correo Electrónico del Cliente *",
  "documents.clientName": "Nombre del Cliente",
  "documents.requestedDocuments": "Documentos Solicitados *",
  "documents.renameFolder": "Renombrar Carpeta",
  "documents.selectADestinationFolder": "Seleccione una carpeta de destino.",
  "documents.deleteDocument": "¿Eliminar documento?",
  "settings.individual": "Individual",
  "settings.business": "Empresa",
  "settings.buyer": "Comprador",
  "settings.seller": "Vendedor",
  "settings.chooseYourPreferredTheme": "Elija su tema preferido",
  "settings.light": "Claro",
  "settings.dark": "Oscuro",
  "settings.system": "Sistema",
  "settings.manufacturing": "Manufactura",
  "settings.insurance": "Seguros",
  "settings.realEstate": "Bienes Raíces",
  "settings.automotive": "Automotriz",
  "settings.importexport": "Importación/Exportación",
  "settings.other": "Otro",
  "settings.brandingWhitelabel": "Marca y Etiqueta Blanca",
  "settings.customizeThePocketfilerExperience": "Personalice la experiencia PocketFiler para sus clientes.",
  "settings.organizationLogo": "Logotipo de la Organización",
  "settings.provideADirectLink": "Proporcione un enlace directo a su logotipo PNG transparente o SVG.",
  "settings.primaryThemeColor": "Color de Tema Principal",
  "settings.selectAHexColor": "Seleccione un código de color hexadecimal para representar los acentos principales de su marca.",
  "settings.accentHoverColor": "Color de Acento / Hover",
  "settings.selectAHexColor1": "Seleccione un color hexadecimal para estados hover, resaltados y elementos de acento.",
  "settings.customDomain": "Dominio Personalizado",
  "settings.ensureYouConfigureA": "Asegúrese de configurar un registro CNAME que apunte a pocketfiler.com.",
  "settings.cancellationScheduled": "Cancelación programada",
  "settings.yourLastPaymentFailed": "Su último pago falló. Por favor actualice su método de pago para mantener el acceso.",
  "settings.chooseYourPlan": "Elija Su Plan",
  "settings.monthly": "Mensual",
  "settings.save20": "Ahorre 20%",
  "settings.current": "Actual",
  "settings.popular": "Popular",
  "settings.contactSales": "Contactar Ventas",
  "settings.googleCalendar": "Google Calendar",
  "settings.syncYourPocketfilerMeetings": "Sincronice sus reuniones PocketFiler con Google Calendar",
  "settings.settingsPageErrorDebug": "Error de Página de Configuración (debug)",
  "invoices.createInvoice": "Crear Factura",
  "invoices.createANewInvoice": "Crear una nueva factura para un cliente",
  "invoices.selectClient": "Seleccionar Cliente",
  "invoices.dueDate": "Fecha de Vencimiento",
  "invoices.clientName": "Nombre del Cliente",
  "invoices.clientEmail": "Correo Electrónico del Cliente",
  "invoices.lineItems": "Elementos de Línea",
  "invoices.description": "Descripción",
  "invoices.qty": "Cant.",
  "invoices.price": "Precio",
  "invoices.tax": "Impuesto %",
  "invoices.total": "Total",
  "invoices.subtotal": "Subtotal:",
  "invoices.discount": "Descuento:",
  "invoices.tax1": "Impuesto:",
  "invoices.total1": "Total:",
  "invoices.notesOptional": "Notas (opcional)",
  "invoices.invoices": "Facturas",
  "invoices.manageAndTrackYour": "Administre y rastree sus facturas",
  "invoices.totalInvoiced": "Total Facturado",
  "invoices.paid": "Pagado",
  "invoices.outstanding": "Pendiente",
  "invoices.totalInvoices": "Total de Facturas",
  "invoices.allInvoices": "Todas las Facturas",
  "invoices.myInvoices": "Mis Facturas",
  "invoices.receivedInvoices": "Facturas Recibidas",
  "invoices.noInvoicesYet": "Aún no hay facturas",
  "meetings.join": "Unirse",
  "meetings.end": "Finalizar",
  "meetings.meetingTitle": "Título de la Reunión",
  "meetings.date": "Fecha",
  "meetings.time": "Hora",
  "meetings.duration": "Duración",
  "meetings.repeat": "Repetir",
  "meetings.doesNotRepeat": "No se repite",
  "meetings.weekly": "Semanalmente",
  "meetings.every2Weeks": "Cada 2 semanas",
  "meetings.monthly": "Mensualmente",
  "meetings.invitePeopleOptional": "Invitar Personas (opcional)",
  "meetings.cancel": "Cancelar",
  "meetings.meetings": "Reuniones",
  "companyprofile.companyProfile": "Perfil de la Empresa",
  "companyprofile.manageYourBusinessProfile": "Gestione su perfil empresarial y equipo",
  "companyprofile.publicProfile": "Perfil Público",
  "companyprofile.basicInformation": "Información Básica",
  "companyprofile.essentialDetailsAboutYour": "Detalles esenciales sobre su empresa",
  "companyprofile.companyName": "Nombre de la Empresa",
  "companyprofile.tagline": "Lema",
  "companyprofile.industry": "Industria",
  "companyprofile.companyType": "Tipo de Empresa",
  "companyprofile.description": "Descripción",
  "companyprofile.companyDetails": "Detalles de la Empresa",
  "companyprofile.additionalInformationAboutYour": "Información adicional sobre su negocio",
  "companyprofile.yearEstablished": "Año de Establecimiento",
  "companyprofile.numberOfEmployees": "Número de Empleados",
  "companyprofile.certifications": "Certificaciones",
  "companyprofile.enterCertificationsSeparatedBy": "Ingrese las certificaciones separadas por comas",
  "companyprofile.languagesSpoken": "Idiomas Hablados",
  "companyprofile.shippingRegions": "Regiones de Envío",
  "companyprofile.contactInformation": "Información de Contacto",
  "companyprofile.howPotentialPartnersCan": "Cómo pueden contactarle los socios potenciales",
  "companyprofile.website": "Sitio Web",
  "companyprofile.email": "Correo Electrónico",
  "companyprofile.phone": "Teléfono",
  "companyprofile.country": "País",
  "companyprofile.city": "Ciudad",
  "companyprofile.address": "Dirección",
  "companyprofile.teamMembers": "Miembros del Equipo",
  "companyprofile.manageUsersWithinYour": "Gestione usuarios dentro de su organización",
  "companyprofile.role": "Rol",
  "companyprofile.admin": "Administrador",
  "companyprofile.member": "Miembro",
  "companyprofile.viewer": "Visualizador",
  "companyprofile.titleOptional": "Título (opcional)",
  "companyprofile.name": "Nombre",
  "companyprofile.title": "Título",
  "companyprofile.status": "Estado",
  "companyprofile.actions": "Acciones",
  "companyprofile.owner": "Propietario",
  "companyprofile.copyInviteLink": "Copiar Enlace de Invitación",
  "companyprofile.removeMember": "Remover Miembro",
  "companyprofile.removeTeamMember": "Remover Miembro del Equipo",
  "companyprofile.cancel": "Cancelar",
  "products.productsServices": "Productos y Servicios",
  "products.description": "Descripción",
  "products.pricing": "Precios",
  "products.price": "Precio",
  "products.unit": "Unidad",
  "products.details": "Detalles",
  "products.minOrderQty": "Cantidad Mínima de Pedido",
  "products.leadTime": "Tiempo de Entrega",
  "products.category": "Categoría",
  "products.currency": "Moneda",
  "products.leadTimeDays": "Tiempo de Entrega (días)",
  "products.active": "Activo",
  "products.showInCatalog": "Mostrar en catálogo",
  "products.cancel": "Cancelar",
  "developersettings.reveal": "Revelar",
  "developersettings.copy": "Copiar",
  "developersettings.hide": "Ocultar",
  "developersettings.securityWarning": "Advertencia de Seguridad",
  "developersettings.neverShareThisKey": "Nunca comparta esta clave públicamente o en código del lado del cliente",
  "developersettings.anyoneWithThisKey": "Cualquiera con esta clave puede leer y modificar sus datos",
  "developersettings.ifCompromisedRevokeImmediately": "Si se ve comprometida, revóquela inmediatamente y genere una nueva clave",
  "developersettings.iUnderstandAndAccept": "Entiendo y acepto la responsabilidad por la seguridad de esta clave",
  "developersettings.cancel": "Cancelar",
  "developersettings.revealKey": "Revelar Clave",
  "developersettings.accessDenied": "Acceso Denegado",
  "developersettings.onlyBusinessAccountsHave": "Solo las cuentas empresariales tienen acceso a la Configuración de Desarrollador.",
  "developersettings.developerOverview": "Resumen de Desarrollador",
  "developersettings.manageYourApiKeys": "Gestione sus claves API y endpoints de Webhook para integraciones de terceros.",
  "developersettings.secretApiKeys": "Claves API Secretas",
  "developersettings.interactiveApiDocumentationRarr": "Documentación Interactiva de API &rarr;",
  "developersettings.name": "Nombre",
  "developersettings.key": "Clave",
  "developersettings.createdAt": "Creado en",
  "developersettings.status": "Estado",
  "developersettings.actions": "Acciones",
  "developersettings.webhookEndpoints": "Endpoints de Webhook",
  "developersettings.url": "URL",
  "developersettings.events": "Eventos",
  "developersettings.description": "Descripción",
  "developersettings.done": "Hecho",
  "developersettings.addWebhookEndpoint": "Agregar Endpoint de Webhook",
  "developersettings.payloadUrl": "URL del Payload",
  "developersettings.eventsToSend": "Eventos a enviar",
  "developersettings.sendMeEverything": "Enviarme todo (*)",
  "developersettings.dealStatusChangedDealstatuschanged": "Estado del Acuerdo Modificado (deal.status_changed)",
  "developersettings.documentUploadedDocumentuploaded": "Documento Subido (document.uploaded)",
  "developersettings.descriptionOptional": "Descripción (Opcional)",
  "analytics.noDataAvailableFor": "No hay datos disponibles para este período.",
  "analytics.noDealsFound": "No se encontraron acuerdos.",
  "analytics.noClientDataAvailable": "No hay datos de clientes disponibles para este período.",
  "analytics.client": "Cliente",
  "analytics.invoices": "Facturas",
  "analytics.revenue": "Ingresos",
  "analytics.totalPipeline": "Pipeline Total",
  "analytics.noRecentActivityFor": "No hay actividad reciente para este período.",
  "analytics.pipelineOverview": "Resumen del Pipeline",
  "analytics.goToDeals": "Ir a Acuerdos",
  "analytics.analyticsDashboard": "Panel de Analíticas",
  "analytics.trackYourBusinessPerformance": "Rastree el rendimiento e insights de su negocio",
  "analytics.last7Days": "Últimos 7 días",
  "analytics.last30Days": "Últimos 30 días",
  "analytics.last90Days": "Últimos 90 días",
  "analytics.lastYear": "Último año",
  "analytics.overview": "Resumen",
  "analytics.myPerformance": "Mi Rendimiento",
  "analytics.currentDealsByStatus": "Acuerdos actuales por estado",
  "analytics.revenueTrendsOverLast": "Tendencias de ingresos en los últimos 6 meses",
  "analytics.accountsGeneratingTheMost": "Cuentas que generan más ingresos",
  "analytics.currentCashFlowOverview": "Resumen actual del flujo de efectivo",
  "analytics.latestBusinessActivitiesAnd": "Últimas actividades comerciales y actualizaciones",
  "compliance.complianceCenter": "Centro de Cumplimiento",
  "compliance.hsCodesTariffsSanctions": "Códigos HS, aranceles, control de sanciones y controles de exportación",
  "compliance.hsCodeClassification": "Clasificación de Código HS",
  "compliance.productDescription": "Descripción del Producto",
  "compliance.tariffCalculator": "Calculadora de Aranceles",
  "compliance.estimateImportDutiesBased": "Estime los derechos de importación basados en el código HS y la ruta comercial.",
  "compliance.hsCode": "Código HS",
  "compliance.declaredValueUsd": "Valor Declarado (USD)",
  "compliance.originCountry": "País de Origen",
  "compliance.destinationCountry": "País de Destino",
  "compliance.dutyRate": "Tasa de Derechos:",
  "compliance.totalRate": "Tasa Total:",
  "compliance.estDuty": "Derechos Est.:",
  "compliance.totalEstCost": "Costo Total Est.:",
  "compliance.tradeAgreements": "Acuerdos Comerciales:",
  "compliance.sanctionsScreening": "Control de Sanciones",
  "compliance.screenEntitiesAgainstOfac": "Controle entidades contra la lista SDN de OFAC y sanciones de países.",
  "compliance.entityName": "Nombre de la Entidad",
  "compliance.type": "Tipo",
  "compliance.company": "Empresa",
  "compliance.individual": "Individual",
  "compliance.vessel": "Embarcación",
  "compliance.countryOptional": "País (opcional)",
  "compliance.usSanctionedCountries": "Países Sancionados por EE.UU.",
  "compliance.exportControlCheck": "Verificación de Control de Exportación",
  "compliance.aipoweredEaritarClassificationGuidance": "Orientación de clasificación EAR/ITAR impulsada por IA. No constituye asesoramiento legal.",
  "compliance.producttechnologyDescription": "Descripción del Producto/Tecnología",
  "compliance.hsCodeOptional": "Código HS (opcional)",
  "compliance.endUseOptional": "Uso Final (opcional)",
  "compliance.licenseRequired": "Licencia Requerida",
  "compliance.recommendations": "Recomendaciones:",
  "compliance.complianceHistory": "Historial de Cumplimiento",
  "compliance.recentComplianceChecksFor": "Verificaciones de cumplimiento recientes para su organización.",
  "compliance.noComplianceChecksYet": "Aún no hay verificaciones de cumplimiento. Ejecute su primera verificación arriba.",
  "intelligence.marketIntelligence": "Inteligencia de Mercado",
  "intelligence.anonymizedTradeDataAnd": "Datos comerciales anonimizados y referencias de la plataforma PocketFiler",
  "intelligence.demandByCategory": "Demanda por Categoría",
  "intelligence.whatBuyersAreSourcing": "Lo que los compradores están buscando en la plataforma (últimos 90 días)",
  "intelligence.noDemandDataYet": "Aún no hay datos de demanda. Los datos se completan a medida que se crean RFQ en la plataforma.",
  "intelligence.byIndustry": "Por Industria",
  "intelligence.noSupplierDataYet": "Aún no hay datos de proveedores.",
  "intelligence.byCountry": "Por País",
  "intelligence.byType": "Por Tipo",
  "intelligence.byVerification": "Por Verificación",
  "intelligence.noDataYet": "Aún no hay datos.",
  "intelligence.yourPerformanceVsPlatform": "Su Rendimiento vs Plataforma",
  "intelligence.seeHowYouStack": "Vea cómo se compara contra los promedios de la plataforma",
  "intelligence.completeSomeDealsTo": "Complete algunos acuerdos para ver referencias.",
  "virtualoffices.virtualOffices": "Oficinas Virtuales",
  "virtualoffices.manageYourBrandedWorkspaces": "Gestione sus espacios de trabajo con marca",
  "virtualoffices.officeName": "Nombre de la Oficina",
  "virtualoffices.industry": "Industria",
  "virtualoffices.languagesServed": "Idiomas Atendidos",
  "virtualoffices.descriptionOptional": "Descripción (opcional)",
  "virtualoffices.documentChecklist": "Lista de Verificación de Documentos",
  "virtualoffices.languages": "Idiomas",
  "tasks.tasks": "Tareas",
  "tasks.noTasksYet": "Aún no hay tareas",
  "tasks.dragTasksHere": "Arrastre tareas aquí",
  "tasks.createNewTask": "Crear Nueva Tarea",
  "tasks.descriptionOptional": "Descripción (Opcional)",
  "tasks.relatedDealOptional": "Acuerdo Relacionado (Opcional)",
  "tasks.noDealAttached": "No hay acuerdo adjunto",
  "tasks.assignees": "Asignados",
  "tasks.noTeamMembersAvailable": "No hay miembros del equipo disponibles. Solo se puede asignar a miembros activos.",
  "tasks.cancel": "Cancelar",
  "tasks.description": "Descripción",
  "tasks.status": "Estado",
  "tasks.relatedDeal": "Acuerdo relacionado",
  "tasks.noAssignees": "Sin asignados",
  "tasks.areYouAbsolutelySure": "¿Está usted absolutamente seguro?",
  "events.events": "Eventos",
  "events.tradeShowsWebinarsAnd": "Ferias comerciales, webinars y eventos de networking",
  "events.createEvent": "Crear Evento",
  "events.title": "Título",
  "events.description": "Descripción",
  "events.category": "Categoría",
  "events.type": "Tipo",
  "events.locationUrl": "Ubicación / URL",
  "events.startDateTime": "Fecha y Hora de Inicio",
  "events.endDateTime": "Fecha y Hora de Finalización",
  "events.maxAttendeesOptional": "Máximo de Asistentes (opcional)",
  "events.cancel": "Cancelar",
  "events.allCategories": "Todas las Categorías",
  "events.noEventsFoundCreate": "No se encontraron eventos. ¡Cree el primero!",
  "events.featured": "Destacado",
  "events.previous": "Anterior",
  "events.next": "Siguiente",
  "status.pendingDocuments": "Documentos Pendientes",
  "status.pendingSignature": "Firma Pendiente",
  "status.pendingPayment": "Pago Pendiente",
  "status.completed": "Completado",
  "status.updated": "Actualizado",
  "status.onHold": "En Espera",
  "activity.deal": "Operación",
  "activity.action.analyzed": "Analizado",
  "activity.action.uploaded": "Subido",
  "activity.action.downloaded": "Descargado",
  "activity.action.previewed": "Previsualizado",
  "activity.action.shared": "Compartido",
  "activity.action.status_changed": "Estado cambiado",
  "activity.action.updated": "Actualizado",
  "activity.action.created": "Creado",
  "activity.action.archived": "Archivado",
  "activity.action.restored": "Restaurado",
  "analytics.totalRevenue": "Ingresos Totales",
  "analytics.totalDeals": "Tratos Totales",
  "analytics.conversionRate": "Tasa de Conversión",
  "analytics.avgDealValue": "Valor Promedio por Trato",
  "analytics.dealPipeline": "Pipeline de Tratos",
  "analytics.monthlyRevenue": "Ingresos Mensuales",
  "analytics.topClientsByRevenue": "Principales Clientes por Ingresos",
  "analytics.invoiceHealth": "Estado de Facturas",
  "analytics.paid": "Pagado",
  "analytics.pendingPayment": "Pago Pendiente",
  "companyprofile.saveProfile": "Guardar Perfil",
  "companyprofile.makeVisible": "Hacer visible su empresa en el directorio",
  "companyprofile.tab.basicInfo": "Información Básica",
  "companyprofile.tab.details": "Detalles",
  "companyprofile.tab.contact": "Contacto",
  "companyprofile.tab.team": "Equipo",
  "companyprofile.tab.verification": "Verificación",
  "companyprofile.selectType": "Seleccionar tipo",
  "companyprofile.describePlaceholder": "Describa su empresa, productos y servicios...",
  "companyprofile.industry.other": "Otro",
  "companyprofile.preview": "Vista previa",
  "companyprofile.ph.companyName": "Su Empresa S.A.",
  "companyprofile.ph.tagline": "Productos de calidad, alcance global",
  "companyprofile.ph.selectIndustry": "Seleccionar industria",
  "companyprofile.ph.selectSize": "Seleccionar tamaño",
  "companyprofile.ph.certifications": "ISO 9001, CE, FDA (separados por comas)",
  "companyprofile.ph.languages": "Español, Inglés, Chino",
  "companyprofile.ph.exportRegions": "América del Norte, Europa, Asia",
  "companyprofile.ph.selectCountry": "Seleccionar país",
  "companyprofile.ph.city": "Los Ángeles",
  "companyprofile.ph.teamName": "Nombre del miembro del equipo",
  "companyprofile.ph.addTitle": "Agregar título...",
  "companyprofile.inviteTeamMember": "Invitar Miembro del Equipo",
  "companyprofile.invitationSent": "Invitación Enviada Exitosamente",
  "virtualoffices.newOffice": "Nueva Oficina",
  "virtualoffices.createOffice": "Crear Oficina Virtual",
  "virtualoffices.reviewChecklist": "Revisar Lista de Verificación de Documentos",
  "virtualoffices.setupDesc": "Configure un nuevo espacio de trabajo con marca para su empresa",
  "virtualoffices.customizeDesc": "Personalice los documentos que necesita de los clientes",
  "virtualoffices.ph.officeName": "ej., García Seguros - Pólizas de Auto",
  "virtualoffices.ph.description": "Describa el enfoque de su oficina...",
  "virtualoffices.ph.addDocument": "Agregar documento personalizado...",
  "virtualoffices.generating": "Generando...",
  "virtualoffices.aiChecklist": "Lista de verificación generada por IA para",
  "virtualoffices.clients": "Clientes",
  "virtualoffices.pending": "Pendiente",
  "virtualoffices.invite": "Invitar",
  "virtualoffices.ind.manufacturing": "Manufactura",
  "virtualoffices.ind.insurance": "Seguros",
  "virtualoffices.ind.real_estate": "Bienes Raíces",
  "virtualoffices.ind.automotive": "Automotriz",
  "virtualoffices.ind.import_export": "Importación/Exportación",
  "virtualoffices.ind.other": "Otro",
  "messages.conversations": "Conversaciones",
  "messages.searchPlaceholder": "Buscar mensajes...",
  "messages.noConversations": "No hay conversaciones",
  "messages.send": "Enviar",
  "messages.selectConversation": "Seleccione una Conversación",
  "messages.selectConversationDesc": "Elija una conversación de la barra lateral para comenzar a chatear",
  "messages.support": "Soporte",
  "messages.client": "Cliente",
  "messages.deal": "Negocio",
  "meetings.subtitle": "Programar y gestionar reuniones de video",
  "meetings.upcoming": "Próximas",
  "meetings.past": "Pasadas",
  "meetings.schedule": "Programar",
  "meetings.startInstant": "Iniciar instantánea",
  "meetings.startNow": "Iniciar ahora",
  "meetings.noPast": "No hay reuniones pasadas",
  "meetings.noUpcoming": "No hay reuniones próximas",
  "meetings.createMeeting": "Crear reunión",
  "meetings.startInstantMeeting": "Iniciar reunión instantánea",
  "meetings.scheduleMeeting": "Programar reunión",
  "meetings.scheduleDesc": "Programe una reunión de video y envíe invitaciones.",
  "meetings.invitePeople": "Invitar personas (opcional)",
  "meetings.15min": "15 minutos",
  "meetings.30min": "30 minutos",
  "meetings.45min": "45 minutos",
  "meetings.allowRecording": "Permitir grabación",
  "meetings.recordingDesc": "Permite al anfitrión grabar esta reunión",
  "meetings.waitingRoom": "Sala de espera",
  "meetings.waitingRoomDesc": "Los participantes deben ser admitidos por el anfitrión antes de unirse",
  "meetings.emailPlaceholder": "correo@ejemplo.com",
  "meetings.cancelConfirm": "¿Cancelar esta reunión?",
  "meetings.cancelMeeting": "Cancelar reunión",
  "documents.title": "Documentos",
  "documents.viewAll": "Ver Todos",
  "documents.archived": "Archivado",
  "documents.requestDocs": "Solicitar Docs",
  "documents.upload": "Subir",
  "documents.allDocuments": "Todos los Documentos",
  "documents.searchPlaceholder": "Buscar documentos...",
  "documents.addTag": "Agregar etiqueta...",
  "documents.uploadDesc": "Arrastre y suelte archivos o haga clic para explorar. Se admiten PDF, imágenes y documentos de Word.",
  "documents.emailPlaceholder": "cliente@ejemplo.com",
  "documents.shareMsgPlaceholder": "Aquí está el documento que solicitó...",
  "documents.requestDesc": "Envíe un enlace de carga segura a un cliente por correo electrónico.",
  "documents.namePlaceholder": "Juan Pérez",
  "documents.requestMsgPlaceholder": "Por favor suba los siguientes documentos...",
  "documents.folderName": "Nombre de carpeta",
  "documents.selectDestination": "Seleccione una carpeta de destino.",
  "documents.statusUploaded": "Subido",
  "documents.statusAnalyzed": "Analizado",
  "documents.statusArchived": "Archivado",
  "documents.allTypes": "Todos los Tipos",
  "documents.inArchive": "en archivo",
  "templates.allTemplates": "Todas las Plantillas",
  "templates.editTemplate": "Editar Plantilla",
  "templates.createCustomTemplate": "Crear Plantilla Personalizada",
  "templates.editDesc": "Actualice su plantilla de documento",
  "templates.createDesc": "Cree su propia plantilla de documento reutilizable",
  "templates.ph.templateName": "ej., Acuerdo de Confidencialidad Personalizado",
  "templates.ph.description": "Breve descripción de la plantilla",
  "templates.ph.content": "Ingrese el contenido de su plantilla aquí...",
  "templates.saving": "Guardando...",
  "templates.creating": "Creando...",
  "templates.saveChanges": "Guardar Cambios",
  "templates.createTemplate": "Crear Plantilla",
  "templates.searchPlaceholder": "Buscar plantillas...",
  "templates.popularTemplates": "Plantillas Populares",
  "templates.defaultTemplates": "Plantillas Predeterminadas",
  "templates.deleteTemplate": "Eliminar Plantilla",
  "templates.preview": "Vista Previa",
  "templates.description": "Descripción",
  "products.searchPlaceholder": "Buscar productos...",
  "products.ph.service": "Servicios de Consultoría",
  "products.ph.product": "Widget Pro 3000",
  "products.selectCategory": "Seleccionar categoría",
  "products.ph.describe": "Describa su producto o servicio...",
  "products.noMatches": "No se encontraron coincidencias",
  "products.noProducts": "Aún no hay productos o servicios",
  "products.serviceDetails": "Detalles del servicio",
  "products.productDetails": "Detalles del producto",
  "products.inactive": "Inactivo",
  "products.deleteConfirm": "¿Eliminar este elemento?",
  "products.saveChanges": "Guardar Cambios",
  "products.addItem": "Agregar Elemento",
  "products.priceOnRequest": "Precio bajo consulta",
  "products.perUnit": "Por Unidad",
  "tasks.searchPlaceholder": "Buscar tareas...",
  "tasks.ph.title": "ej. Revisar documentos legales",
  "tasks.ph.description": "Agregar más contexto a esta tarea...",
  "tasks.selectDeal": "Seleccionar un negocio para adjuntar",
  "tasks.noTasks": "No hay tareas en esta columna",
  "tasks.deleteTask": "Eliminar Tarea",
  "settings.tabs.branding": "Marca",
  "settings.tabs.payments": "Pagos",
  "settings.tabs.plan": "Plan",
  "settings.tabs.integrations": "Integraciones",
  "settings.appearance": "Apariencia",
  "settings.saveBranding": "Guardar Marca",
  "settings.yourPlan": "Su Plan",
  "settings.ph.logoUrl": "https://example.com/logo.png",
  "settings.ph.customDomain": "deals.yourcompany.com",
  "settings.calendarFeedGenerated": "¡URL del feed del calendario generada!",
  "settings.plan.free": "Gratuito",
  "settings.plan.pro": "Pro",
  "settings.plan.smallBusiness": "Pequeña Empresa",
  "settings.plan.businessPro": "Business Pro",
  "settings.plan.scale": "Escala",
  "settings.plan.enterprise": "Empresarial",
  "dealroom.meetings": "Reuniones",
  "dealroom.startMeeting": "Iniciar Reunión",
  "dealroom.noMeetings": "Aún no hay reuniones vinculadas a este negocio",
  "dealroom.noMeetingsDesc": "Inicie una reunión o programe una para comenzar",
  "dealroom.failedCreateMeeting": "Error al crear la reunión",
  "dealroom.finalizedContract": "Contrato Finalizado — Listo para Firma",
  "dealroom.previewNotSupported": "Vista previa no compatible",
  "dealroom.aiMayTakeMoment": "Esto puede tomar un momento.",
  "dealroom.aiAnalysisGenerated": "Se ha generado análisis de IA para los siguientes documentos:",
  "dealroom.docsUnanalyzed": "Los siguientes documentos permanecen sin analizar:",
  "dealroom.analyzingDocs": "Analizando documentos...",
  "dealroom.finalizeWarning": "Esta acción no se puede deshacer. El estado del negocio cambiará a Pendiente de Firma y todas las partes podrán firmar el contrato.",
  "dealroom.cannotRevert": "No se puede revertir desde Pendiente de Firma",
  "compliance.ph.productDesc": "ej., Pernos de acero inoxidable, M10 x 50mm...",
  "compliance.ph.exportDesc": "Describa el producto o tecnología que se está exportando...",
  "compliance.select": "Seleccionar...",
  "compliance.selectCountry": "Seleccionar país...",
  "events.tradeShow": "Feria Comercial",
  "events.webinar": "Seminario Web",
  "events.networking": "Networking",
  "events.conference": "Conferencia",
  "events.workshop": "Taller",
  "events.ph.title": "Título del evento",
  "events.ph.location": "Dirección del lugar o URL de la reunión",
  "events.ph.maxAttendees": "Dejar vacío para ilimitado",
  "events.searchPlaceholder": "Buscar eventos...",
  "events.cancelRsvp": "Cancelar RSVP",
  "events.rsvp": "RSVP",
  "rfq.expired": "Vencido",
  "rfq.createRfq": "Crear Solicitud de Cotización",
  "rfq.visibility": "Visibilidad",
  "rfq.public": "Público - Todos los proveedores pueden ver",
  "rfq.private": "Privado - Solo por invitación",
  "rfq.quantity": "Cantidad",
  "rfq.unit": "Unidad",
  "rfq.pieces": "Piezas",
  "rfq.kilograms": "Kilogramos",
  "rfq.meters": "Metros",
  "rfq.squareMeters": "Metros Cuadrados",
  "rfq.units": "Unidades",
  "rfq.sets": "Conjuntos",
  "rfq.boxes": "Cajas",
  "rfq.deliveryLocation": "Lugar de Entrega",
  "rfq.deliveryDeadline": "Fecha Límite de Entrega",
  "rfq.specialRequirements": "Requisitos Especiales",
  "rfq.title": "Solicitudes de Cotización",
  "rfq.subtitle": "Explore solicitudes de abastecimiento o publique la suya",
  "rfq.rfqsPosted": "RFQs Publicados",
  "rfq.openRfqs": "RFQs Abiertos",
  "rfq.quotesSent": "Cotizaciones Enviadas",
  "rfq.winRate": "Tasa de Éxito",
  "rfq.allCategories": "Todas las Categorías",
  "rfq.noRfqsFound": "No se encontraron RFQs",
  "rfq.noRfqsYet": "Aún no hay RFQs",
  "meetings.biweekly": "Cada 2 semanas",
  "meetings.cancelSeries": "Cancelar toda la serie",
  "meetings.cancelThisMeeting": "Cancelar esta reunión",
  "meetings.nextInSeries": "Siguiente en la serie",
  "nav.contractTemplates": "Contratos",
  "contracts.title": "Plantillas de Contratos",
  "contracts.subtitle": "Generación de documentos legales con IA. Seleccione una plantilla para comenzar.",
  "documents.create": "Crear",
  "createDoc.untitledDocument": "Documento sin título",
  "createDoc.save": "Guardar",
  "createDoc.export": "Exportar",
  "createDoc.aiAssist": "Asistente IA",
  "createDoc.generate": "Generar",
  "createDoc.generating": "Generando...",
  "createDoc.cancel": "Cancelar",
  "createDoc.translate": "Traducir",
  "createDoc.translateTitle": "Traducir Documento",
  "createDoc.translateTo": "Traducir a",
  "createDoc.translateNow": "Traducir",
  "createDoc.translating": "Traduciendo...",
  "createDoc.translated": "Documento traducido exitosamente",
  "createDoc.translateFailed": "Error al traducir",
  "verification.status": "Estado de Verificación",
  "verification.inProgress": "Verificación en Progreso",
  "verification.getVerified": "Verificarse",
  "verification.cancelRequest": "Cancelar Solicitud",
  "verification.submit": "Enviar para Verificación",
  "verification.submitting": "Enviando...",
  "verification.uploadDocs": "Subir Documentos",
  "verification.level": "Nivel de Verificación",
  "verification.selectDocType": "Seleccione tipo de documento...",
  "contracts.generate": "Generar",
  "contracts.backToTemplates": "Volver a plantillas",
  "contracts.required": "Requerido",
  "contracts.modify": "Modificar",
  "contracts.finalize": "Finalizar",
  "contracts.modifyPrompt": "Dile a la IA cómo modificar este documento:",
  "contracts.applyChanges": "Aplicar Cambios",
  "contracts.confirmDelete": "¿Eliminar este borrador?",
  "contracts.loadFailed": "Error al cargar plantillas",
  "contracts.generating": "Generando documento...",
  "contracts.nda": "Acuerdo Mutuo de Confidencialidad",
  "contracts.sow": "Declaración de Trabajo",
  "contracts.msa": "Acuerdo Marco de Servicios",
  "contracts.contractor": "Contrato de Contratista Independiente",
  "contracts.loi": "Carta de Intención",
  "templates.deleting": "Eliminando...",
  "templates.noDescription": "Sin descripción.",
  "templates.use": "Usar",
  "templates.confirmDeleteDesc": "Esto eliminará permanentemente esta plantilla. Esta acción no se puede deshacer.",
  "templates.lib.ndaMutual": "NDA Mutuo",
  "templates.lib.ndaMutualDesc": "Acuerdo estándar de confidencialidad mutua para proteger información confidencial entre dos partes.",
  "templates.lib.purchaseAgreement": "Acuerdo de Compra",
  "templates.lib.purchaseAgreementDesc": "Plantilla estándar de acuerdo de compra para ventas B2B con términos y condiciones.",
  "templates.lib.serviceAgreement": "Acuerdo de Servicios",
  "templates.lib.serviceAgreementDesc": "Plantilla de acuerdo de servicios profesionales con alcance de trabajo y entregables.",
  "templates.lib.priceQuote": "Cotización",
  "templates.lib.priceQuoteDesc": "Plantilla profesional de cotización para proporcionar precios a clientes potenciales.",
  "templates.lib.invoice": "Factura",
  "templates.lib.invoiceDesc": "Plantilla profesional de factura para facturar a clientes y rastrear pagos.",
  "templates.lib.loi": "Carta de Intención",
  "templates.lib.loiDesc": "Plantilla de carta de intención para expresar interés en un acuerdo comercial potencial.",
  "settings.security": "Seguridad",
  "security.twoFactor": "Autenticación de Dos Factores",
  "security.twoFactorDesc": "Agregue una capa extra de seguridad con verificación TOTP.",
  "security.enabled": "Habilitado",
  "security.disabled": "Deshabilitado",
  "security.enable2FA": "Habilitar 2FA",
  "security.disable": "Deshabilitar",
  "security.activeSessions": "Sesiones Activas",
  "security.activeSessionsDesc": "Dispositivos actualmente conectados.",
  "security.logoutAll": "Cerrar todas las sesiones",
  "security.lastUsed": "Último uso",
  "security.currentSession": "Actual",
  "security.loginHistory": "Historial de Inicio de Sesión",
  "security.successfulLogin": "Inicio de sesión exitoso",
  "security.failedLogin": "Intento fallido",
  "security.setup2FA": "Configurar Autenticación de Dos Factores",
  "security.scanQR": "Escanee este código QR con su aplicación de autenticación.",
  "security.secretKey": "Clave Secreta",
  "security.enterCode": "Ingrese el código de 6 dígitos",
  "security.verify": "Verificar y Habilitar",
  "security.cancel": "Cancelar",
  "security.saveBackupCodes": "Guarde Sus Códigos de Respaldo",
  "security.backupCodesDesc": "Guarde estos códigos en un lugar seguro.",
  "security.copyAll": "Copiar Todos",
  "security.done": "Listo",
  "security.disable2FA": "Deshabilitar 2FA",
  "security.password": "Contraseña",
  "security.confirmDisable": "Deshabilitar 2FA",
  "feedback.button": "Comentarios",
  "feedback.title": "Enviar Comentarios",
  "feedback.type": "Tipo",
  "feedback.typeBug": "Error",
  "feedback.typeFeature": "Función",
  "feedback.typeGeneral": "General",
  "feedback.description": "Descripción",
  "feedback.descPlaceholder": "Cuéntanos qué pasó...",
  "feedback.priority": "Prioridad",
  "feedback.priorityLow": "Baja",
  "feedback.priorityMedium": "Media",
  "feedback.priorityHigh": "Alta",
  "feedback.submit": "Enviar",
  "feedback.submitting": "Enviando...",
  "feedback.thanks": "¡Gracias! Lo revisaremos.",
};

export default es;
